import Link from "next/link";
import Image from "next/image";
import FAIcon from "@/components/icons/faIcon";

const PANEL_WIDTH = 1220;
const PANEL_HEIGHT = 820;
const PANEL_GLOW = "shadow-[0_34px_110px_rgba(6,4,12,0.18)]";
const DROPDOWN_SHADOW = "shadow-3xl shadow-black/20";
const BACKGROUND_OVERLAY =
  "p-10 bg-gradient-to-r from-zinc-900/30 to-transparent";

const FEATURED = {
  eyebrow: "SML Connect",
  title: "Audits, actions and risk visibility in one connected platform.",
  description:
    "Explore the platform page to see how SML Connect brings operational safety activity into one clearer working view.",
  href: "/sml-connect",
  cta: "Explore the platform",
  image: "/images/other/sml-platform-laptop.webp",
  imagePosition: "78% center",

  fullPanelBackground: true,
  metrics: ["Audits", "Actions", "Incident logs"],
};

const ITEMS = [
  {
    title: "Platform overview",
    description:
      "Bringing audits, actions and risk visibility into one connected platform.",
    href: "/sml-connect",
  },
];

function MenuArrowIcon({ className = "", noMargin = false, size }) {
  return (
    <FAIcon
      icon="arrow-right"
      className={className}
      noMargin={noMargin}
      size={size}
    />
  );
}

function DesktopDropdown({ id, onNavigate }) {
  return (
    <div
      id={id}
      style={{
        width: `${PANEL_WIDTH}px`,
        maxWidth: "calc(100vw - 2.5rem)",
        height: `${PANEL_HEIGHT}px`,
      }}
      className={`relative overflow-hidden rounded-lg p-8 ${PANEL_GLOW} ${DROPDOWN_SHADOW} bg-transparent`}
    >
      <div className="absolute inset-0 overflow-hidden">
        <Image
          src={FEATURED.image}
          alt={FEATURED.title}
          fill
          className="object-cover"
          style={{ objectPosition: FEATURED.imagePosition }}
          sizes="100vw"
          priority
        />
        <div
          className={`absolute inset-0 ${BACKGROUND_OVERLAY}`}
          aria-hidden="true"
        />
      </div>

      <div className="relative h-full z-10 grid gap-3 md:grid-cols-1 ">
        {ITEMS.map((item, idx) => (
          <Link
            key={item.title}
            href={item.href}
            onClick={onNavigate}
            className={`group flex min-h-full w-full flex-col justify-center rounded-lg p-5 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer ${
              idx === 0 ? "" : "bg-white"
            }`}
          >
            {idx === 0 ? (
              <div className="mb-4 flex ">
                <Image
                  src="/images/logo/connect/sml-connect-logo-light.svg"
                  alt="SML Connect"
                  width={120}
                  height={30}
                  className="h-auto w-56"
                />
              </div>
            ) : null}
            <div className="space-y-3 ">
              <p className="max-w-md text-4xl font-semibold leading-10 text-white">
                {item.description}
              </p>

              <div className="mt-4">
                <span className="inline-flex cursor-pointer items-center justify-center rounded-full bg-primary px-6 py-4 text-sm font-semibold text-black uppercase transition-transform duration-200">
                  Take a look
                  <FAIcon
                    icon="arrow-right"
                    size={12}
                    className="ml-2"
                    noMargin
                  />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function MobileContent({ onNavigate }) {
  return (
    <div className="space-y-1.5 pb-2.5">
      {ITEMS.map((item) => (
        <Link
          key={item.title}
          href={item.href}
          onClick={onNavigate}
          className="flex min-w-0 items-start justify-between gap-3 rounded-md bg-white px-3.5 py-2.5"
        >
          <div className="min-w-0">
            <p className="text-md font-semibold text-[#06040c]">{item.title}</p>
            <p className="mt-1 text-[0.84rem] leading-4.5 text-[#06040c]/64">
              {item.description}
            </p>
          </div>
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary text-[#06040c]">
            <MenuArrowIcon className="mx-auto" noMargin size={14} />
          </span>
        </Link>
      ))}
    </div>
  );
}

const ourPlatformMenu = {
  label: "SML Connect",
  DesktopDropdown,
  MobileContent,
};

export default ourPlatformMenu;
